import React from 'react'
import { FaImage } from 'react-icons/fa'
import { Box, Button, ImageViewer } from '@/components/lib'

import FileChooser from '../includes/FileChooser'

export default function Image ({ dataType, value, onChange, participant }) {
  return (
    <Box>
      {!value?.fileName &&
        <FileChooser
          accept='image/*'
          forType='participant' forObject={participant}
          onComplete={({ storedName, name, expectedUrl }) => onChange({ name, fileName: storedName, url: expectedUrl })}
          trigger={<Button size='sm' variant='outline' colorPalette='primary'><Box as={FaImage} mr={2} /> Choose an image</Button>}
        />}
      {value?.url &&
        <ImageViewer url={value.url} onRemove={() => onChange('')} />}
    </Box>
  )
}
